import PersonPage from './person-page';
export default PersonPage;